import * as React from 'react';
import Button from 'common/button/button';
import WithSideBarAndNavBar from 'layouts/withSideBarAndNavBar/withSideBarAndNavBar';
import './work-a-diary.scss';
import { ReactComponent as LeftArrow } from 'assets/icons/left-arrow.svg';
import { ReactComponent as RightArrow } from 'assets/icons/right-arrow.svg';
import { ReactComponent as SolidPinIcon } from 'assets/icons/pin_solid_new.svg';
import { ReactComponent as PinIcon } from 'assets/icons/pin.svg';
import { ReactComponent as ActionIcon } from 'assets/icons/action.svg';
import { ReactComponent as MessageIcon } from 'assets/icons/message.svg';
import workADiaryData from 'dummy-data/work-a-diary.json';
import { useNavigate } from 'react-router-dom';
import { Popup } from 'semantic-ui-react';

import CalendarInput from 'common/calendar-input/calendar-input';
import Label from 'common/label/label';
import SideScreen from './side-screen/side-screen';
import Select, { SingleValue } from 'react-select';
import { ReactComponent as ArrowDownIcon } from 'assets/icons/arrowdown.svg';
import DateSelector from 'common/date-selector/date-selector';
import NavButton from 'common/nav-button/nav-button';
import moment from 'moment';
import useLoadingStore from 'zustands/useLoadingStore';
import { AxiosResponse } from 'axios';
import useApi from 'hooks/useApi';
import useErrorLog from 'hooks/useErrorLog';
import { IOption } from 'types/common';
import { INoticeItem } from 'types/notice';
import { identity } from '@fullcalendar/core/internal';
import useAlertConfirmStore from 'zustands/useAlertConfirmStore';
import useUserStore from 'zustands/useUserStore';

const noticeOptions = [
  { value: '0', label: '전체' },
  { value: '1', label: '지시사항' },
  { value: '2', label: '특이사항' },
];

const WorkADiary: React.FC = () => {
  const navigate = useNavigate();

  const { setLoadingState } = useLoadingStore();
  const { setModalState } = useAlertConfirmStore();
  const { userSeq } = useUserStore();

  const { webApiNode } = useApi();
  const { checkErrorLog } = useErrorLog();

  const [date, setDate] = React.useState<Date>(new Date()); // 선택한 날짜
  const [noticeType, setNoticeType] = React.useState<IOption>({ value: '0', label: '전체' }); // 업무일지 분류 타입
  const [noticeData, setNoticeData] = React.useState<INoticeItem[]>([]); // 지시사항 데이터
  const [selectedNoticeItem, setSelectedNoticeItem] = React.useState<INoticeItem>(); // 선택한 데이터(사이드 스크린 표시)
  const [showSideScreen, setShowSideScreen] = React.useState<boolean>(false); // 사이드 스크린 표시여부

  const todayDate = new Date().toISOString().replace(/T.*$/, '');
  const [additionalCompletionModal, setAdditionalCompletionModal] = React.useState<boolean>(false);
  const [displaySideScreen, setDisplaySideScreen] = React.useState<boolean>(false);
  const [today, setToday] = React.useState<string>(todayDate);
  const [currentWorkADiary, setCurrentWorkADiary] = React.useState<any>();
  const [workADiary, setWorkADiary] = React.useState<any>([]);

  const fetchData = async () => {
    try {
      setLoadingState({ isFetchLoading: true });
      const { data }: AxiosResponse['data'] = await webApiNode('post', `/auth/getNoticeList`, {
        DATE: moment(date).format('YYYY-MM-DD'),
      });
      console.log('/auth/getNoticeList_data', data);

      if (data.resultCode === 0) {
        let formatNoticeData: INoticeItem[] = [];
        for (let key in data.resultData) {
          console.log('key', key);
          console.log('data.resultData[key]', data.resultData[key]);
          data.resultData[key].map((i: any) => {
            formatNoticeData.push({
              MEMBER_SEQ: i.MEMBER_SEQ,
              NOTICE_SEQ: i.NOTICE_SEQ,
              STORE: i.STORE,
              STORE_SEQ: i.STORE_SEQ,
              favorite: i.favorite === '1' ? true : false,
              TITLE: i.TITLE,
              CONTENTS: i.CONTENTS,
              EMP_NAME: i.EMP_NAME,
              IMG_LIST: i.IMG_LIST,
              comment: i.comment,
              ADDDATE: moment(i.ADDDATE).toDate(),
              CREATE_TIME: moment(i.CREATE_TIME).toDate(),
            });
          });
        }
        formatNoticeData = formatNoticeData
          .sort((a, b) => (a.favorite ? -1 : 1))
          .sort((a, b) => (a.favorite && a.STORE === '1' ? -1 : 1));
        setNoticeData(formatNoticeData);
      } else {
        throw new Error(data.resultMsg);
      }
    } catch (err) {
      checkErrorLog(err, ' /auth/getNoticeList');
    } finally {
      setLoadingState({ isFetchLoading: false });
    }
  };

  // 날짜 선택 핸들러
  const handleDateChange = (date: Date) => {
    setDate(date);
  };

  // 사이드 스크린 표시 여부 토글
  const toggleSideScreen = () => {
    setShowSideScreen((prev) => !prev);
  };

  // 댓글 보기 클릭
  const selectNoticeItem = (item: INoticeItem) => {
    setSelectedNoticeItem(item);
    toggleSideScreen();
  };

  // 업무일지 상세보기
  const handleAdditionalCompletionModal = () => {
    setAdditionalCompletionModal(true);
  };

  // 업무일지 추가/수정 화면 이동하기
  const handleToggleChecklistModal = (noticeItem?: INoticeItem) => {
    if (noticeItem) {
      navigate(`/add-new-diary`, {
        state: {
          noticeItem,
        },
      });
    } else {
      navigate(`/add-new-diary`);
    }
  };

  const dropdownStyles = {
    control: (styles: any, { data, isDisabled, isFocused, isSelected }: any) => ({
      ...styles,
      backgroundColor: '#FFFFFF',
      borderColor: '#E9E9E9',
      borderRadius: '8px',
      width: '114px',
      height: '42px',
      fontFamily: 'Spoqa Han Sans Neo',
      fontWeight: 400,
    }),
    multiValueRemove: (base: any) => ({ ...base, display: 'none' }),
  };

  // 업무일지 타입 선택 핸들링
  const handleNoticeType = (newValue: SingleValue<IOption>) => {
    if (newValue) setNoticeType(newValue);
  };

  // 업무일지 삭제
  const deleteNotice = async (noticeItem: INoticeItem) => {
    try {
      setLoadingState({ isFetchLoading: true });
      const { data }: AxiosResponse['data'] = await webApiNode('post', `/auth/updateNotice`, {
        CLOSE_FLAG: '1',
        NOTICE_SEQ: noticeItem.NOTICE_SEQ,
      });
      console.log('/auth/updateNotice_data', data);

      if (data.resultCode === 0) {
        fetchData();
      } else {
        throw new Error(data.resultMsg);
      }
    } catch (err) {
      checkErrorLog(err, ' /auth/updateNotice');
    } finally {
      setLoadingState({ isFetchLoading: false });
    }
  };

  const handlePinClick = (seq: number, favorite: boolean) => {
    if (favorite) {
      setModalState({
        isModalShow: true,
        title: '상단고정 해제',
        desc: `작성일 기준으로 정렬됩니다`,
        okBtnText: '확인',
        okCallback: () => fixNotice(seq),
      });
    } else {
      setModalState({
        isModalShow: true,
        title: '상단고정',
        desc: `해당 업무일지를 상단에 고정합니다\n최신 고정순으로 정렬됩니다`,
        okBtnText: '확인',
        okCallback: () => fixNotice(seq),
      });
    }
  };

  const fixNotice = async (noticeSeq: number) => {
    try {
      setLoadingState({ isFetchLoading: true });
      const { data }: AxiosResponse['data'] = await webApiNode('post', `/auth/setNoticeFavorite`, {
        NOTICE_SEQ: noticeSeq,
      });
      console.log('/auth/setNoticeFavorite_data', data);

      if (data.resultCode === 0) {
        fetchData();
      } else {
        throw new Error(data.resultMsg);
      }
    } catch (err) {
      checkErrorLog(err, ' /auth/setNoticeFavorite');
    } finally {
      setLoadingState({ isFetchLoading: false });
    }
  };

  const popupStyle = {
    borderRadius: 8,
    width: '102px',
    height: '84px',
    border: '1px solid #E9E9E9',
    boxShadow: '2px 2px 20px rgba(0, 0, 0, 0.06)',
  };

  // 댓글 업데이트 콜백 함수
  const handleCommentUpdate = () => {
    fetchData();
  };

  React.useEffect(() => {
    fetchData();
  }, [date]);

  let filteredNoticeData = noticeData;
  if (noticeType.label === '지시사항') {
    filteredNoticeData = filteredNoticeData.filter((i) => i.STORE === '1');
  }
  if (noticeType.label === '특이사항') {
    filteredNoticeData = filteredNoticeData.filter((i) => i.STORE === '0');
  }

  return (
    <div className="work-a-diary__background">
      <WithSideBarAndNavBar>
        <div className="work-a-diary">
          <div className="work-a-diary__head">
            <div className="work-a-diary__head__text" onClick={handleAdditionalCompletionModal}>
              업무일지
            </div>
            <div className="work-a-diary__head__button">
              <Button label="+추가하기" type="type2" action={() => handleToggleChecklistModal()} />
            </div>
          </div>
          <div className="work-a-diary__dates">
            <div className="work-a-diary__arrows__left">
              <NavButton direction="LEFT" action={() => handleDateChange(moment(date).subtract(1, 'days').toDate())} />
            </div>
            <div>
              <DateSelector onChange={handleDateChange} value={date} />
            </div>
            <div className="work-a-diary__arrows__right">
              <NavButton direction="RIGHT" action={() => handleDateChange(moment(date).add(1, 'days').toDate())} />
            </div>

            <div className="work-a-diary__today-button">
              <Button label="오늘" type="type1" action={() => handleDateChange(new Date())} />
            </div>
            <div>
              <Select
                components={{
                  IndicatorSeparator: () => null,
                  DropdownIndicator: () => (
                    <div style={{ paddingRight: '15px' }}>
                      <ArrowDownIcon />
                    </div>
                  ),
                }}
                styles={dropdownStyles}
                isSearchable={false}
                value={noticeType}
                options={noticeOptions}
                onChange={handleNoticeType}
              />
            </div>
          </div>
          <div className="work-a-diary__content">
            {filteredNoticeData.length > 0 &&
              filteredNoticeData.map((i) => {
                return (
                  <div className="work-a-diary-card" key={`${moment(date).format('YYYY.MM.DD')}_${i.NOTICE_SEQ}`}>
                    <div className="work-a-diary-card__head">
                      <button
                        className="work-a-diary-card__head__icon"
                        onClick={() => handlePinClick(i.NOTICE_SEQ, i.favorite)}>
                        {i.favorite ? <SolidPinIcon /> : <PinIcon />}
                      </button>
                      <div className="work-a-diary-card__head__text">{i.TITLE}</div>
                      <div>
                        {i.STORE === '1' ? (
                          <Label text="지시사항" type="instructions" />
                        ) : (
                          <Label text="특이사항" type="special-note" />
                        )}
                      </div>
                      {i.MEMBER_SEQ && Number(i.MEMBER_SEQ) === userSeq && (
                        <div className="work-a-diary-card__head__action">
                          <Popup
                            on="click"
                            trigger={
                              <div className="checklist__popup__icon">
                                <ActionIcon />
                              </div>
                            }
                            position="bottom center"
                            style={popupStyle}
                            basic
                            flowing
                            hoverable>
                            <div className="checklist__popups">
                              <div
                                className="checklist__popup__resend-invite"
                                onClick={() => {
                                  handleToggleChecklistModal(i);
                                }}>
                                수정
                              </div>
                              <div
                                className="checklist__popup__delete-invite"
                                onClick={() => {
                                  setModalState({
                                    isModalShow: true,
                                    title: '업무일지 삭제',
                                    desc: '해당 업무일지를 삭제합니다',
                                    okBtnText: '확인',
                                    okCallback: () => deleteNotice(i),
                                    isWarning: true,
                                  });
                                }}>
                                삭제
                              </div>
                            </div>
                          </Popup>
                        </div>
                      )}
                    </div>
                    <div className="work-a-diary-card__body">
                      <div className="work-a-diary-card__body__content">{i.CONTENTS}</div>
                      <div className="work-a-diary-card__body__comment">
                        <div
                          className="work-a-diary-card__body__comment__div"
                          onClick={() => {
                            selectNoticeItem(i);
                          }}>
                          <div className="work-a-diary-card__body__comment__icon-number">
                            <MessageIcon />
                            <span className="work-a-diary-card__body__comment__number">{i.comment}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="work-a-diary-card__footer">
                      <div>
                        {/* <img src={item.profile.profileImage} alt="image" className="work-a-diary-card__footer__image" /> */}
                      </div>
                      <div className="work-a-diary-card__footer__profile-name">{i.EMP_NAME}</div>
                      <div className="work-a-diary-card__footer__vertical">|</div>
                      <div className="work-a-diary-card__footer__date">{moment(i.ADDDATE).format('YYYY.MM.DD')}</div>
                    </div>
                  </div>
                );
              })}
            {filteredNoticeData.length === 0 && (
              <div className="emptyArea">
                <div className="emptyText">업무일지가 없습니다!</div>
              </div>
            )}
          </div>
        </div>
      </WithSideBarAndNavBar>
      {showSideScreen && (
        <SideScreen
          onClose={toggleSideScreen}
          selectNotice={selectedNoticeItem}
          onCommentUpdate={handleCommentUpdate}
        />
      )}
    </div>
  );
};
export default WorkADiary;
